// "use client"

// import { useRef, useEffect, useState, useMemo } from "react"
// import "bootstrap/dist/css/bootstrap.min.css"
// import { Button, Spinner } from "react-bootstrap"
// import DashNavbar from "./DashNavbar"
// import Sidebar from "./Sidebar"
// import { useLocation, useNavigate } from "react-router-dom"
// import html2pdf from "html2pdf.js"
// import axios from "axios"
// import Swal from "sweetalert2"
// import VetrinaStamp from "../../Assets/VetrinaStamp.png"
// import appointmentLetterBackgroundImage from "../../Assets/Vetrina Offer Letter-1.png";

// // Layout Configuration
// const PAGE_WIDTH_PX = 595;
// const PAGE_HEIGHT_PX = 842;
// const HEADER_CONTENT_LEFT_PX = 68;
// const HEADER_CONTENT_RIGHT_MARGIN_PX = 60;
// const HEADER_CONTENT_TOP_PX = 83;
// const CONTENT_LEFT_PX = 68;
// const CONTENT_WIDTH_PX = 475;
// const CONTENT_TOP_PAGE_1_PX = 205; 
// const CONTENT_TOP_SUBSEQUENT_PX = 110; 
// const CONTENT_BOTTOM_MARGIN_PX = 180; // Margin to ensure space for footer inline
// const STAMP_WIDTH_PX = 100;
// const STAMP_HEIGHT_PX = 100;
// const SIGNATURE_WIDTH_PX = 120;
// const SIGNATURE_HEIGHT_PX = 60;

// // Derived Calculations
// const MAX_CONTENT_FILL_HEIGHT_PAGE_1 = PAGE_HEIGHT_PX - CONTENT_TOP_PAGE_1_PX - CONTENT_BOTTOM_MARGIN_PX;
// const MAX_CONTENT_HEIGHT_SUBSEQUENT = PAGE_HEIGHT_PX - CONTENT_TOP_SUBSEQUENT_PX - CONTENT_BOTTOM_MARGIN_PX;

// // Helper Functions
// const formatDate = (date) => {
//   if (!date) return ""
//   try {
//     const d = new Date(date)
//     if (isNaN(d.getTime())) return date
//     const day = String(d.getDate()).padStart(2, "0")
//     const month = String(d.getMonth() + 1).padStart(2, "0")
//     const year = d.getFullYear()
//     return `${day}/${month}/${year}`
//   } catch (e) { return "Error Date" }
// }

// const AppointmentLetter = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const formData = location.state || {};
//   const appointmentLetterRef = useRef(null);
//   const measureRef = useRef(null);

//   const [renderedPagesData, setRenderedPagesData] = useState([]);
//   const [isCalculatingPages, setIsCalculatingPages] = useState(false);
//   const [isDataValid, setIsDataValid] = useState(false);

//   const safeData = useMemo(() => ({
//     candidateName: formData.candidateName || "Candidate Name",
//     date: formatDate(formData.date),
//     address: formData.address || "[Address]",
//     pinCode: formData.pinCode || "[Pin Code]",
//     mobileNumber: formData.mobileNumber || "[Mobile Number]",
//     hrName: formData.hr?.name || "[HR Manager Name]",
//     hrTitle: "HR Manager",
//     customContent: formData.customContent || "",
//     generationMethod: formData.generationMethod,
//     signaturePreviewUrl: formData.signaturePreviewUrl || null,
//     letter_id: formData.letter_id,
//   }), [formData]);

//   useEffect(() => {
//     if (!safeData.candidateName || !safeData.date || !safeData.signaturePreviewUrl || !safeData.letter_id) {
//       setIsDataValid(false);
//     } else {
//       setIsDataValid(true);
//     }
//   }, [safeData]);

//   useEffect(() => {
//     if (!isDataValid || !measureRef.current || safeData.generationMethod !== 'custom') return;

//     setIsCalculatingPages(true);
//     setTimeout(() => {
//       if (!measureRef.current) return;
//       const calculatedPages = [];
//       const contentLines = safeData.customContent.split('\n');
//       let currentPageContent = "";
//       const measureDiv = measureRef.current;
//       measureDiv.style.width = `${CONTENT_WIDTH_PX}px`;

//       contentLines.forEach((line) => {
//         const testContent = currentPageContent + (currentPageContent ? '\n' : '') + line;
//         measureDiv.innerText = testContent;
//         const estimatedHeight = measureDiv.scrollHeight;

//         const isFirstPage = calculatedPages.length === 0;
//         const maxHeight = isFirstPage ? MAX_CONTENT_FILL_HEIGHT_PAGE_1 : MAX_CONTENT_HEIGHT_SUBSEQUENT;

//         if (estimatedHeight > maxHeight && currentPageContent.trim()) {
//           calculatedPages.push(currentPageContent);
//           currentPageContent = line;
//           measureDiv.innerText = line;
//         } else {
//           currentPageContent = testContent;
//         }
//       });

//       if (currentPageContent.trim()) calculatedPages.push(currentPageContent);
//       setRenderedPagesData(calculatedPages);
//       setIsCalculatingPages(false);
//     }, 100);
//   }, [isDataValid, safeData.generationMethod, safeData.customContent]);

//   const downloadAsPDF = async () => {
//     const elementToCapture = appointmentLetterRef.current;
//     const opt = {
//       margin: 0,
//       filename: `${safeData.candidateName}_appointment_letter.pdf`,
//       image: { type: "jpeg", quality: 0.98 },
//       html2canvas: { scale: 2, useCORS: true },
//       jsPDF: { unit: "px", format: [PAGE_WIDTH_PX, PAGE_HEIGHT_PX], orientation: "portrait" },
//     };

//     try {
//       Swal.fire({ title: 'Generating PDF...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });
//       const pdf = html2pdf().from(elementToCapture).set(opt);
//       const pdfBlob = await pdf.output('blob');
//       const data = new FormData();
//       data.append("pdf", pdfBlob, "appointment.pdf");
//       data.append("letter_id", safeData.letter_id);

//       await axios.post("https://raasbackend.vetrinahealthcare.com/save_appointment_pdf/", data);
//       Swal.fire({ icon: "success", title: "Saved!", timer: 2000, showConfirmButton: false }).then(() => navigate("/appoinmentletterform"));
//     } catch (error) {
//       Swal.fire("Error", "Failed to save PDF", "error");
//     }
//   };

//   // Header Section with Text Justify
//   const renderHeader = () => (
//     <div style={{ position: "absolute", top: `${HEADER_CONTENT_TOP_PX}px`, left: `${HEADER_CONTENT_LEFT_PX}px`, width: `${CONTENT_WIDTH_PX}px`, zIndex: 2 }}>
//         <div style={{ textAlign: "right", fontSize: "10px", marginBottom: "10px" }}>Date - {safeData.date}</div>
//         <div style={{ fontSize: "10px", lineHeight: "1.4", textAlign: "justify" }}>
//             To,<br />
//             <span style={{ fontWeight: "bold" }}>{safeData.candidateName},</span><br />
//             Address - {safeData.address}<br />
//             Pin code - {safeData.pinCode}<br />
//             Mobile No.: {safeData.mobileNumber}
//         </div>
//     </div>
//   );

//   // Footer Section positioned to follow exact text end
//   const renderFooterInline = () => (
//     <div style={{ marginTop: '30px', width: '100%', zIndex: 2 }}>
//       <div style={{ textAlign: "left", fontSize: "10px", marginBottom: "5px" }}>Thanks & Regards</div>

//       <div style={{ position: "relative", height: "70px", marginTop: '5px' }}>
//           {/* Stamp - Positioned relative to signature container */}
//           <div style={{ position: "absolute", top: '-25px', left: '60px', width: `${STAMP_WIDTH_PX}px`, zIndex: 3 }}>
//             <img src={VetrinaStamp} alt="Stamp" style={{ width: "100%" }} />
//           </div>
//           {/* Signature */}
//           {safeData.signaturePreviewUrl && (
//             <div style={{ position: "absolute", top: '-10px', left: '0px', width: `${SIGNATURE_WIDTH_PX}px`, zIndex: 4 }}>
//               <img src={safeData.signaturePreviewUrl} alt="Signature" style={{ width: "100%", maxHeight: "50px", objectFit: "contain" }}/>
//             </div>
//           )}
//       </div>

//       <div style={{ textAlign: "left", fontSize: "10px", marginTop: "5px", lineHeight: "1.3" }}>
//         Mr / Mrs. {safeData.hrName} <br /> 
//         {safeData.hrTitle}<br /> 
//         Vetrina Healthcare Pvt. Ltd.
//       </div>
//     </div>
//   );

//   const renderCustomContent = (contentChunk, pageIndex) => {
//     const isLastPage = pageIndex === renderedPagesData.length - 1;
//     const topMargin = pageIndex === 0 ? CONTENT_TOP_PAGE_1_PX : CONTENT_TOP_SUBSEQUENT_PX;
//     return (
//       <div style={{
//         position: "absolute", top: `${topMargin}px`, left: `${CONTENT_LEFT_PX}px`,
//         width: `${CONTENT_WIDTH_PX}px`, zIndex: 2, fontSize: "10px", lineHeight: "1.5",
//         textAlign: "justify", whiteSpace: "pre-wrap", overflowWrap: "break-word",
//       }}>
//         {contentChunk}
//         {/* Render Footer inline only on the last page after text ends */}
//         {isLastPage && renderFooterInline()}
//       </div>
//     );
//   }

//   if (!isDataValid && !isCalculatingPages) {
//     return <div className="text-center mt-5">Validating data...</div>;
//   }

//   return (
//     <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
//       <DashNavbar />
//       <div style={{ display: "flex", flexGrow: 1 }}>
//         <Sidebar />
//         <div style={{ flexGrow: 1, backgroundColor: "#e0e0e0", padding: "30px 20px", overflowY: 'auto', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
//           <div style={{ width: '100%', maxWidth: `${PAGE_WIDTH_PX}px`, display: 'flex', justifyContent: 'flex-end', marginBottom: '20px' }}>
//             <Button onClick={downloadAsPDF} variant="primary" size="sm" disabled={isCalculatingPages || renderedPagesData.length === 0}>
//               {isCalculatingPages ? <Spinner size="sm" /> : "Save Final PDF"}
//             </Button>
//           </div>

//           <div ref={measureRef} style={{ position: 'absolute', top: '-9999px', fontSize: '10px', lineHeight: '1.5', whiteSpace: 'pre-wrap', width: `${CONTENT_WIDTH_PX}px`, visibility: 'hidden' }}></div>

//           <div ref={appointmentLetterRef} style={{ boxShadow: '0 0 10px rgba(0,0,0,0.2)' }}>
//             {renderedPagesData.map((pageContent, index) => (
//               <div key={index} style={{ width: `${PAGE_WIDTH_PX}px`, height: `${PAGE_HEIGHT_PX}px`, backgroundColor: "#ffffff", position: "relative", overflow: "hidden", margin: "0 0 10px 0", display: 'block' }}>
//                 <img src={appointmentLetterBackgroundImage} alt="Background" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 1 }} />
//                 {index === 0 && renderHeader()}
//                 {renderCustomContent(pageContent, index)}
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AppointmentLetter;





"use client"

import { useRef, useEffect, useState, useMemo } from "react"
import "bootstrap/dist/css/bootstrap.min.css"
import { Button, Spinner } from "react-bootstrap"
import DashNavbar from "./DashNavbar"
import Sidebar from "./Sidebar"
import { useLocation, useNavigate } from "react-router-dom"
import html2pdf from "html2pdf.js"
import axios from "axios"
import Swal from "sweetalert2"
import VetrinaStamp from "../../Assets/VetrinaStamp.png"
// IMPORT YOUR APPOINTMENT LETTER BACKGROUND IMAGE
// Make sure this path is correct and the image exists in your Assets folder
import appointmentLetterBackgroundImage from "../../Assets/Vetrina Offer Letter-1.png"; // Example, adjust if needed

// Layout Configuration (Assuming these are appropriate for Appointment Letters too)
const PAGE_WIDTH_PX = 595;
const PAGE_HEIGHT_PX = 842;
const HEADER_CONTENT_LEFT_PX = 68;
const HEADER_CONTENT_RIGHT_MARGIN_PX = 60;
const HEADER_CONTENT_TOP_PX = 83;
const CONTENT_LEFT_PX = 68;
const CONTENT_WIDTH_PX = 475;
const CONTENT_TOP_PAGE_1_PX = 200; // Start content lower on page 1
const CONTENT_TOP_SUBSEQUENT_PX = 110; // Start content higher on subsequent pages
const CONTENT_BOTTOM_MARGIN_PX = 90; // Space before footer might start
const FOOTER_TOP_PX = 640; // Where the footer block starts (relative to page top)
const FOOTER_LEFT_PX = 68;
const FOOTER_WIDTH_PX = 475;
const STAMP_OFFSET_TOP_PX = -50; // Offset relative to FOOTER_TOP_PX (590px absolute)
const STAMP_OFFSET_LEFT_PX = 72; // Offset relative to FOOTER_LEFT_PX (140px absolute)
const STAMP_WIDTH_PX = 100;
const STAMP_HEIGHT_PX = 100;
const SIGNATURE_OFFSET_TOP_PX = -10; // Offset relative to FOOTER_TOP_PX (630px absolute)
const SIGNATURE_OFFSET_LEFT_PX = 0; // Offset relative to FOOTER_LEFT_PX (68px absolute)
const SIGNATURE_WIDTH_PX = 100;
const SIGNATURE_HEIGHT_PX = 50;
// =====================================================================
// ===== DERIVED CALCULATIONS (From Modified Code) ====================
// =====================================================================
// Cut off content at 570px (20px before stamp at 590px) to maximize page space while preventing stamp overlap
const FOOTER_AREA_TOP_PX = FOOTER_TOP_PX - 70; // 570px Y-coord
const MAX_CONTENT_FILL_HEIGHT_PAGE_1 = FOOTER_AREA_TOP_PX - CONTENT_TOP_PAGE_1_PX; // 370px max on page 1
const MAX_CONTENT_HEIGHT_SUBSEQUENT = FOOTER_AREA_TOP_PX - CONTENT_TOP_SUBSEQUENT_PX; // 460px max on subsequent pages
// =====================================================================


// Helper Functions
const formatDate = (date) => {
  if (!date) return ""
  try {
    if (typeof date === "string" && /^\d{2}\/\d{2}\/\d{4}$/.test(date)) {
      return date
    }
    const d = new Date(date)
    if (isNaN(d.getTime())) {
      const isoDate = new Date(Date.parse(date))
      if (isNaN(isoDate.getTime())) {
        console.warn("Invalid date:", date)
        return "Invalid Date"
      }
      const day = String(isoDate.getDate()).padStart(2, "0")
      const month = String(isoDate.getMonth() + 1).padStart(2, "0")
      const year = isoDate.getFullYear()
      return `${day}/${month}/${year}`
    }
    const day = String(d.getDate()).padStart(2, "0")
    const month = String(d.getMonth() + 1).padStart(2, "0")
    const year = d.getFullYear()
    return `${day}/${month}/${year}`
  } catch (e) {
    console.error("Date format error:", date, e)
    return "Error Date"
  }
}

const cleanCustomContent = (html) => {
  if (!html) return "";
  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${html}</div>`, 'text/html');
    const root = doc.body.firstElementChild;
    
    // Force font size of 8.5px, line-height of 1.2, and word-break on all table cells and headers
    const cells = root.querySelectorAll('td, th');
    cells.forEach(cell => {
      cell.style.fontSize = '8.5px';
      cell.style.lineHeight = '1.2';
      cell.style.wordBreak = 'break-word'; // cleaner than break-all, breaks long words only
      cell.style.overflowWrap = 'break-word';
    });
    
    const tables = root.querySelectorAll('table');
    tables.forEach(table => {
      table.style.fontSize = '8.5px';
      table.style.width = '100%';
      table.style.maxWidth = '100%';
      table.style.tableLayout = 'fixed'; // Force fixed layout so column widths are strictly followed
      table.style.borderCollapse = 'collapse';
      
      // Calculate column count and text distribution
      const rows = Array.from(table.querySelectorAll('tr'));
      if (rows.length === 0) return;
      
      let colCount = 0;
      rows.forEach(row => {
        colCount = Math.max(colCount, row.querySelectorAll('td, th').length);
      });
      
      if (colCount === 0) return;
      
      const maxLens = new Array(colCount).fill(0);
      rows.forEach(row => {
        const cols = row.querySelectorAll('td, th');
        cols.forEach((col, idx) => {
          if (idx < colCount) {
            maxLens[idx] = Math.max(maxLens[idx], col.textContent.trim().length);
          }
        });
      });
      
      const paddedLens = maxLens.map(len => Math.max(len, 6)); // Minimum 6 characters weight
      const totalLen = paddedLens.reduce((sum, len) => sum + len, 0);
      
      let widths = paddedLens.map(len => (len / totalLen) * 100);
      
      // Enforce minimum width of 7% per column to prevent squashing
      let adjusted = false;
      for (let i = 0; i < widths.length; i++) {
        if (widths[i] < 7) {
          widths[i] = 7;
          adjusted = true;
        }
      }
      if (adjusted) {
        const sumAdjusted = widths.reduce((sum, w) => sum + w, 0);
        widths = widths.map(w => (w / sumAdjusted) * 100);
      }
      
      // Apply widths to cells in every row to satisfy all browser rendering engines
      rows.forEach(row => {
        const rowCells = row.querySelectorAll('td, th');
        rowCells.forEach((cell, idx) => {
          if (idx < widths.length) {
            cell.style.width = `${widths[idx].toFixed(2)}%`;
          }
        });
      });
    });
    
    return root.innerHTML;
  } catch (e) {
    console.error("Error cleaning custom content:", e);
    return html;
  }
};

const AppointmentLetter = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const formData = location.state || {}; // Data passed from AppointmentLetterGenerator
  const appointmentLetterRef = useRef(null);
  const measureRef = useRef(null);

  const [renderedPagesData, setRenderedPagesData] = useState([]);
  const [isCalculatingPages, setIsCalculatingPages] = useState(false);
  const [isDataValid, setIsDataValid] = useState(false);

  // Use memoized safeData for stability
  const safeData = useMemo(() => ({
    candidateName: formData.candidateName || "Candidate Name",
    date: formatDate(formData.date),
    joiningDate: formatDate(formData.joiningDate), // Specific to Appointment Letter
    address: formData.address || "[Address]",
    pinCode: formData.pinCode || "[Pin Code]",
    mobileNumber: formData.mobileNumber || "[Mobile Number]",
    hrName: formData.hr?.name || "[HR Manager Name]",
    hrTitle: "HR Executive", // Assuming constant title
    position: formData.position || formData.jobTitle || "[Position]", // Use jobTitle as fallback
    department: formData.department || "[Department]", // Specific to Appointment Letter
    reportingTo: formData.reporting_manager || "[Reporting Manager]",
    basedHQ: formData.headquarter || "[Base HQ]",
    customContent: cleanCustomContent(formData.customContent || ""),
    generationMethod: formData.generationMethod, // Will be 'custom' if coming to this page
    signaturePreviewUrl: formData.signaturePreviewUrl || null,
    user_id: formData.user_id,
    letter_id: formData.letter_id, // CRUCIAL: ID of the created AppointmentLetter record
  }), [formData]);

  // Data Validation Effect
  useEffect(() => {
    console.log("AppointmentLetter Preview State:", formData);
    let isDataMissing = false;
    const missingFields = [];

    // Basic checks
    if (!safeData.candidateName || safeData.candidateName === "Candidate Name") { isDataMissing = true; missingFields.push('candidateName'); }
    if (!safeData.date || safeData.date === "Invalid Date" || safeData.date === "Error Date") { isDataMissing = true; missingFields.push('date'); }
    if (!safeData.hrName || safeData.hrName === "[HR Manager Name]") { isDataMissing = true; missingFields.push('hr (for signature)'); }
    if (!safeData.signaturePreviewUrl) { isDataMissing = true; missingFields.push('signature'); }

    // Address details are needed for the header in all cases (template/custom)
    const headerFields = ['address', 'pinCode', 'mobileNumber'];
    headerFields.forEach(f => {
      const value = safeData[f];
      if (!value || (typeof value === 'string' && value.startsWith('['))) {
        isDataMissing = true;
        if (!missingFields.includes(f)) missingFields.push(f);
      }
    });

    if (safeData.generationMethod === 'custom') {
      if (!safeData.customContent) { isDataMissing = true; missingFields.push('customContent'); }
      if (!safeData.letter_id) { isDataMissing = true; missingFields.push('letter_id (from creation step)'); } // Essential for saving PDF
    }
    // This 'template' block is for future-proofing if you re-add a template method that uses this preview.
    // Currently, AppointmentLetterGenerator doesn't send 'template' method to this page.
    else if (safeData.generationMethod === 'template') {
      if (!safeData.joiningDate || safeData.joiningDate === "Invalid Date" || safeData.joiningDate === "Error Date") {
        isDataMissing = true;
        missingFields.push('joiningDate');
      }
      const templateFields = ['position', 'department', 'reportingTo', 'basedHQ'];
      templateFields.forEach(f => {
        const value = safeData[f];
        if (!value || (typeof value === 'string' && value.startsWith('['))) {
          isDataMissing = true;
          if (!missingFields.includes(f)) missingFields.push(f);
        }
      });
      // For template method, if it ever comes here, letter_id might also be needed if PDF is saved separately.
      // if (!safeData.letter_id) { isDataMissing = true; missingFields.push('letter_id');}
    }
    else {
      isDataMissing = true;
      missingFields.push('generationMethod');
    }

    if (isDataMissing) {
      setIsDataValid(false);
      console.error("AppointmentLetter Preview - Invalid Data:", { safeData, missingFields });
      if (missingFields.length > 0) {
        Swal.fire({
          icon: "error",
          title: "Missing or Invalid Data for Preview",
          text: `Could not load required appointment letter data (${missingFields.join(', ')}). Please ensure all details are provided. Redirecting.`,
          confirmButtonText: "OK"
        }).then(() => { navigate("/appoinmentletterform"); }); // Navigate to your generator/list page
      }
    } else {
      setIsDataValid(true);
    }
  }, [safeData, navigate]);

  // Page Calculation Effect for Custom Content
  useEffect(() => {
    if (!isDataValid || !measureRef.current || safeData.generationMethod !== 'custom') {
      if (safeData.generationMethod === 'template' && isDataValid) {
        // For template, assume one page (or implement specific logic if it can be multi-page)
        setRenderedPagesData(['template_content_placeholder']);
        setIsCalculatingPages(false);
      } else if (safeData.generationMethod !== 'custom') {
        setRenderedPagesData([]); // Clear if not custom and not template
        setIsCalculatingPages(false);
      }
      return;
    }

    setIsCalculatingPages(true);
    // Ensure customContent is available
    if (safeData.customContent) {
      setTimeout(() => {
        if (!measureRef.current) {
          console.error("Measure ref disappeared during calculation.");
          setIsCalculatingPages(false);
          setRenderedPagesData([]);
          return;
        }

        const isHtml = /<[a-z][\s\S]*>/i.test(safeData.customContent);
        let contentBlocks = [];
        if (isHtml) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(`<div>${safeData.customContent}</div>`, 'text/html');
          const root = doc.body.firstElementChild;

          const isBlockElement = (node) => {
            if (node.nodeType !== Node.ELEMENT_NODE) return false;
            const tag = node.tagName.toLowerCase();
            return ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'table', 'ul', 'ol', 'pre', 'blockquote'].includes(tag);
          };

          const traverse = (node) => {
            if (isBlockElement(node)) {
              let wrapper = node.cloneNode(true);
              let ancestor = node.parentNode;
              while (ancestor && ancestor !== root) {
                if (ancestor.nodeType === Node.ELEMENT_NODE) {
                  const tag = ancestor.tagName.toLowerCase();
                  if (ancestor.attributes.length > 0 || ['span', 'font', 'b', 'i', 'u', 'strike', 'strong', 'em'].includes(tag)) {
                    const ancestorClone = ancestor.cloneNode(false);
                    ancestorClone.appendChild(wrapper);
                    wrapper = ancestorClone;
                  }
                }
                ancestor = ancestor.parentNode;
              }
              contentBlocks.push(wrapper.outerHTML);
              return;
            }

            if (node.nodeType === Node.TEXT_NODE && node.textContent && node.textContent.trim()) {
              const p = doc.createElement('p');
              p.textContent = node.textContent.trim();
              let wrapper = p;
              let ancestor = node.parentNode;
              while (ancestor && ancestor !== root) {
                if (ancestor.nodeType === Node.ELEMENT_NODE) {
                  const tag = ancestor.tagName.toLowerCase();
                  if (ancestor.attributes.length > 0 || ['span', 'font', 'b', 'i', 'u', 'strike', 'strong', 'em'].includes(tag)) {
                    const ancestorClone = ancestor.cloneNode(false);
                    ancestorClone.appendChild(wrapper);
                    wrapper = ancestorClone;
                  }
                }
                ancestor = ancestor.parentNode;
              }
              contentBlocks.push(wrapper.outerHTML);
              return;
            }

            if (node.childNodes && node.childNodes.length > 0) {
              Array.from(node.childNodes).forEach(child => traverse(child));
            }
          };

          Array.from(root.childNodes).forEach(child => traverse(child));

          if (contentBlocks.length === 0) {
            contentBlocks = [safeData.customContent];
          }
        } else {
          contentBlocks = safeData.customContent.split('\n');
        }

        const calculatedPages = [];
        let currentPageContent = "";
        const measureDiv = measureRef.current;
        measureDiv.style.width = `${CONTENT_WIDTH_PX}px`;
        measureDiv.style.fontSize = "10px";
        measureDiv.style.lineHeight = "1.4";
        measureDiv.style.fontFamily = "'Arial', sans-serif";
        measureDiv.style.whiteSpace = isHtml ? "normal" : "pre-wrap";
        measureDiv.innerHTML = '';

        const processBlockList = (blocks) => {
          let currentContent = "";

          blocks.forEach((block) => {
            const isTableBlock = isHtml && /^<table/i.test(block.trim());
            const candidateContent = currentContent + (currentContent && !isHtml ? '\n' : '') + block;

            if (isHtml) {
              measureDiv.innerHTML = candidateContent;
            } else {
              measureDiv.innerText = candidateContent;
            }
            const estimatedHeight = measureDiv.scrollHeight;

            const isFirstPage = calculatedPages.length === 0;
            const maxHeightForThisPage = isFirstPage ? MAX_CONTENT_FILL_HEIGHT_PAGE_1 : MAX_CONTENT_HEIGHT_SUBSEQUENT;

            if (estimatedHeight > maxHeightForThisPage) {
              // If the block is a table and doesn't fit on the current page as a whole,
              // split the table row-by-row so rows that fit remain on the current page!
              if (isTableBlock) {
                try {
                  const parser = new DOMParser();
                  const tableDoc = parser.parseFromString(block, 'text/html');
                  const tableEl = tableDoc.querySelector('table');
                  const rows = Array.from(tableEl ? tableEl.querySelectorAll('tr') : []);

                  if (rows.length > 2) {
                    const headerRowHtml = rows[0].outerHTML;
                    const dataRows = rows.slice(1);

                    const createTableString = (rowHtmlList) => {
                      const clone = tableEl.cloneNode(false);
                      clone.innerHTML = `<tbody>${rowHtmlList.join('')}</tbody>`;
                      return clone.outerHTML;
                    };

                    let fitRows = [headerRowHtml];
                    let remainingRows = [];
                    let splitSuccess = false;

                    for (let r = 0; r < dataRows.length; r++) {
                      const testRows = fitRows.concat(dataRows[r].outerHTML);
                      const testTableHtml = createTableString(testRows);
                      measureDiv.innerHTML = currentContent + testTableHtml;

                      if (measureDiv.scrollHeight <= maxHeightForThisPage) {
                        fitRows.push(dataRows[r].outerHTML);
                        splitSuccess = true;
                      } else {
                        remainingRows = dataRows.slice(r).map(row => row.outerHTML);
                        break;
                      }
                    }

                    if (splitSuccess && fitRows.length > 1 && remainingRows.length > 0) {
                      // Table Part 1 fits on current page!
                      const part1Html = createTableString(fitRows);
                      currentContent += (currentContent ? '\n' : '') + part1Html;
                      calculatedPages.push(currentContent);
                      currentContent = "";

                      // Table Part 2 moves to next page (with table headers repeated!)
                      const part2Html = createTableString([headerRowHtml].concat(remainingRows));
                      processBlockList([part2Html]);
                      return;
                    }
                  }
                } catch (err) {
                  console.error("Error splitting table rows:", err);
                }
              }

              // Normal block split
              if (currentContent.trim()) {
                calculatedPages.push(currentContent);
                currentContent = block;
                if (isHtml) {
                  measureDiv.innerHTML = block;
                } else {
                  measureDiv.innerText = block;
                }
              } else {
                currentContent = block;
              }
            } else {
              currentContent += (currentContent && !isHtml ? '\n' : '') + block;
            }
          });

          if (currentContent.trim()) {
            calculatedPages.push(currentContent);
          }
        };

        processBlockList(contentBlocks);

        setRenderedPagesData(calculatedPages);
        setIsCalculatingPages(false);
        console.log(`Custom appointment letter content calculation resulted in ${calculatedPages.length} pages.`);
      }, 100);
    } else {
      // No custom content, so no pages to calculate for custom method
      setRenderedPagesData([]);
      setIsCalculatingPages(false);
      console.log("No custom content provided for page calculation.");
    }
  }, [isDataValid, safeData.generationMethod, safeData.customContent]);

  // PDF Generation Function
  const downloadAsPDF = async () => {
    if (!appointmentLetterRef.current || !isDataValid || renderedPagesData.length === 0) {
      Swal.fire("Error", "Cannot generate PDF. No content pages rendered or data is invalid.", "error");
      return;
    }
    if (safeData.generationMethod === 'custom' && !safeData.letter_id) {
      Swal.fire("Error", "Cannot save PDF. Missing Letter ID for custom letter.", "error");
      return;
    }
    if (!safeData.candidateName || safeData.candidateName === "Candidate Name" || !safeData.hrName || safeData.hrName === "[HR Manager Name]") {
      Swal.fire("Error", "Cannot generate PDF. Missing candidate name or HR name.", "error");
      return;
    }

    const btn = document.getElementById('save-pdf-button-container');
    if (btn) btn.style.visibility = 'hidden';

    Swal.fire({
      title: 'Generating PDF...',
      text: 'Please wait while the appointment letter is being processed.',
      allowOutsideClick: false,
      didOpen: () => { Swal.showLoading(); }
    });

    const elementToCapture = appointmentLetterRef.current;
    const scrollableParent = elementToCapture.parentElement?.parentElement;
    const originalScrollTop = scrollableParent ? scrollableParent.scrollTop : 0;
    if (scrollableParent) scrollableParent.scrollTop = 0;
    window.scrollTo(0, 0);

    const opt = {
      margin: 0,
      filename: `${safeData.candidateName}_appointment_letter.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: {
        scale: 2,
        useCORS: true,
        logging: false,
        scrollX: 0,
        scrollY: 0,
        windowWidth: PAGE_WIDTH_PX,
      },
      jsPDF: { unit: "px", format: [PAGE_WIDTH_PX, PAGE_HEIGHT_PX], orientation: "portrait" },
      pagebreak: { mode: ['css', 'legacy'] }
    };

    try {
      await new Promise(resolve => setTimeout(resolve, 600)); // Wait for images to fully load

      const pdfBlob = await html2pdf().from(elementToCapture).set(opt).output('blob');

      // Restore scroll
      if (scrollableParent) scrollableParent.scrollTop = originalScrollTop;

      if (!pdfBlob || pdfBlob.size === 0) throw new Error("Generated PDF blob is empty.");

      const formDataToSend = new FormData();
      formDataToSend.append("pdf", pdfBlob, `${safeData.candidateName}_appointment_letter.pdf`);
      if (safeData.letter_id) {
        formDataToSend.append("letter_id", safeData.letter_id);
      }

      console.log("Sending Appointment Letter PDF to backend...", safeData.letter_id);
      const response = await axios.post(
        "https://raasbackend.vetrinahealthcare.com/save_appointment_pdf/",
        formDataToSend,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      Swal.close();
      if (btn) btn.style.visibility = 'visible';
      Swal.fire({
        icon: "success",
        title: "Appointment Letter PDF Saved!",
        text: response.data.message || "The generated PDF has been saved successfully.",
        timer: 2500, timerProgressBar: true, showConfirmButton: false,
      }).then(() => {
        navigate("/appoinmentletterform");
      });

    } catch (error) {
      if (btn) btn.style.visibility = 'visible';
      Swal.close();
      console.error("Error during Appointment PDF generation or saving:", error);
      const errorText = error.response?.data?.error || error.message || "An unexpected error occurred.";
      Swal.fire("PDF Generation Failed", `Error: ${errorText}. Please check console logs.`, "error");
    }
  };

  // RENDER FUNCTIONS (Header and Footer can be similar to OfferLetter if layout is same)
  const renderHeader = () => (
    <div style={{
      position: "absolute",
      top: `${HEADER_CONTENT_TOP_PX}px`,
      left: `${HEADER_CONTENT_LEFT_PX}px`,
      width: `${CONTENT_WIDTH_PX}px`,
      zIndex: 2
    }}>
      {/* Date Section - Pinned to the right */}
      <div style={{ textAlign: "right", fontSize: "10px", marginBottom: "10px" }}>
        Date - {safeData.date}
      </div>

      {/* Recipient Section - Justified and Flowing naturally to prevent overlap */}
      <div style={{ fontSize: "10px", lineHeight: "1.4", textAlign: "justify" }}>
        To,<br />
        <span style={{ fontWeight: "bold" }}>{safeData.candidateName},</span><br />
        Address - {safeData.address}<br />
        Pin code - {safeData.pinCode}<br />
        Mobile No.: {safeData.mobileNumber}
      </div>
    </div>
  );
  const renderFooter = () => (
    <div style={{
      position: 'absolute', top: `${FOOTER_TOP_PX}px`, left: `${FOOTER_LEFT_PX}px`,
      width: `${FOOTER_WIDTH_PX}px`, zIndex: 2
    }}>
      {/* <div style={{ position: "absolute", top: `-70px`, left: `0px`, width: "100%", textAlign: "justify", fontSize: "10px" }}>If you have any question or concerns, please feel free to contact us.</div> */}
      <div style={{ position: "absolute", top: `-30px`, left: `0px`, width: "100%", textAlign: "left", fontSize: "10px" }}>Thanks & Regards</div>
      <div style={{ position: "absolute", top: `${STAMP_OFFSET_TOP_PX}px`, left: `${STAMP_OFFSET_LEFT_PX}px`, width: `${STAMP_WIDTH_PX}px`, height: `${STAMP_HEIGHT_PX}px`, zIndex: 3 }}>
        <img src={VetrinaStamp} alt="Vetrina Stamp" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
      </div>
      {safeData.signaturePreviewUrl && (
        <div style={{
          position: "absolute", top: `${SIGNATURE_OFFSET_TOP_PX}px`, left: `${SIGNATURE_OFFSET_LEFT_PX}px`,
          width: `${SIGNATURE_WIDTH_PX}px`, height: `${SIGNATURE_HEIGHT_PX}px`, zIndex: 3
        }}>
          <img src={safeData.signaturePreviewUrl} alt="Signature Preview" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
        </div>
      )}
      <div style={{ position: "absolute", top: `40px`, left: `0px`, width: "100%", textAlign: "left", fontSize: "10px" }}>
        Mr / Mrs. {safeData.hrName} <br /> {safeData.hrTitle}<br /> Vetrina Healthcare Pvt. Ltd.
      </div>
    </div>
  );

  // Appointment Letter Template Content (Specific content for appointment letters)
  const renderAppointmentTemplateContent = () => {
    const topBase = CONTENT_TOP_PAGE_1_PX;
    const leftPos = CONTENT_LEFT_PX;
    const width = CONTENT_WIDTH_PX;
    return (
      <>
        <div style={{ position: "absolute", top: `${topBase}px`, left: `${leftPos}px`, width: `${width}px`, textAlign: "left", zIndex: 2, fontSize: "10px" }}><u>Subject: - Appointment letter for the position of {safeData.position}.</u></div>
        <div style={{ position: "absolute", top: `${topBase + 40}px`, left: `${leftPos}px`, textAlign: "left", zIndex: 2, fontSize: "10px" }}>Dear Mr./Ms. {safeData.candidateName.split(' ')[0]},</div>
        <div style={{ position: "absolute", top: `${topBase + 80}px`, left: `${leftPos}px`, width: `${width}px`, textAlign: "justify", zIndex: 2, fontSize: "10px" }}>
          We are pleased to confirm your appointment to the position of <strong>{safeData.position}</strong> in the <strong>{safeData.department} Department</strong> at <strong>VETRINA HEALTHCARE PVT. LTD.</strong>, effective from your joining date of <strong>{safeData.joiningDate}</strong>.
          You will be reporting to <strong>{safeData.reportingTo}</strong>. Your primary place of work will be <strong>{safeData.basedHQ}</strong>.
        </div>
        <div style={{ position: "absolute", top: `${topBase + 150}px`, left: `${leftPos}px`, width: `${width}px`, textAlign: "justify", zIndex: 2, fontSize: "10px" }}>
          Your employment will be governed by the terms and conditions detailed in this letter and the company's prevailing policies and procedures, which may be amended from time to time.
          You will be on a probation period of three (3) months from your date of joining. Upon successful completion of the probation period, your appointment will be confirmed in writing.
        </div>
        <div style={{ position: "absolute", top: `${topBase + 220}px`, left: `${leftPos}px`, width: `${width}px`, textAlign: "justify", zIndex: 2, fontSize: "10px" }}>
          Further details regarding your role, responsibilities, compensation, and benefits are outlined in the annexures attached herewith (if any) or will be communicated to you by your reporting manager.
        </div>
        <div style={{ position: "absolute", top: `${topBase + 270}px`, left: `${leftPos}px`, width: `${width}px`, textAlign: "justify", zIndex: 2, fontSize: "10px" }}>
          Please sign and return a duplicate copy of this letter as a token of your acceptance of this appointment and its terms.
        </div>
        <div style={{ position: "absolute", top: `${topBase + 310}px`, left: `${leftPos}px`, width: `${width}px`, textAlign: "justify", zIndex: 2, fontSize: "10px" }}>
          We are excited to have you join our team and look forward to a successful and mutually rewarding association.
        </div>
      </>
    );
  };

  // Custom Content Rendering
  const renderCustomContent = (contentChunk, pageIndex) => {
    const topMargin = pageIndex === 0 ? CONTENT_TOP_PAGE_1_PX : CONTENT_TOP_SUBSEQUENT_PX;
    const isHtml = /<[a-z][\s\S]*>/i.test(contentChunk);
    return (
      <div
        className="appointment-letter-custom-content"
        style={{
          position: "absolute", top: `${topMargin}px`, left: `${CONTENT_LEFT_PX}px`,
          width: `${CONTENT_WIDTH_PX}px`, zIndex: 2, fontSize: "10px", lineHeight: "1.4",
          textAlign: "justify", overflowWrap: "break-word",
          whiteSpace: isHtml ? "normal" : "pre-wrap"
        }}
        dangerouslySetInnerHTML={{ __html: contentChunk }}
      />
    );
  }

  // --- Main Render Logic ---
  if (!isDataValid && !isCalculatingPages) {
    return (<div style={{ display: "flex", flexDirection: "column", height: "100vh" }}> <DashNavbar /> <div style={{ display: "flex", flex: 1 }}> <Sidebar /> <div style={{ flexGrow: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px' }}> <p>Validating data or redirecting...</p> </div> </div> </div>);
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100vh", overflow: "hidden" }}>
      <style>{`
        .appointment-letter-custom-content table, .appointment-letter-page table {
          width: 100% !important;
          max-width: 100% !important;
          table-layout: fixed !important;
          border-collapse: collapse !important;
          margin-top: 6px !important;
          margin-bottom: 8px !important;
          font-size: 8.5px !important;
        }
        .appointment-letter-custom-content td, .appointment-letter-custom-content th,
        .appointment-letter-page td, .appointment-letter-page th {
          border: 1px solid #000000 !important;
          padding: 3px 4px !important;
          text-align: left !important;
          vertical-align: top !important;
          font-size: 8.5px !important;
          word-break: break-all !important;
          overflow-wrap: break-word !important;
        }
        .appointment-letter-custom-content th, .appointment-letter-page th {
          background-color: #f2f2f2 !important;
          font-weight: bold !important;
        }
      `}</style>
      <DashNavbar />
      <div style={{ display: "flex", flexGrow: 1, overflow: "hidden" }}>
        <Sidebar />
        <div style={{ flexGrow: 1, backgroundColor: "#e0e0e0", padding: "30px 20px", overflowY: 'auto', display: 'flex', flexDirection: 'column', alignItems: 'center', position: 'relative' }}>
          <div id="save-pdf-button-container" style={{ width: '100%', maxWidth: `${PAGE_WIDTH_PX}px`, display: 'flex', justifyContent: 'flex-end', marginBottom: '20px', paddingRight: '0px' }}>
            <Button onClick={downloadAsPDF} variant="primary" size="lg" disabled={isCalculatingPages || renderedPagesData.length === 0}>
              {isCalculatingPages ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" /> : <i className="fas fa-save me-2"></i>}
              Save Final PDF
            </Button>
          </div>
          <div ref={measureRef} className="appointment-letter-custom-content" style={{ position: 'absolute', top: '-9999px', left: '-9999px', fontSize: '10px', lineHeight: '1.4', overflowWrap: 'break-word', zIndex: -1, fontFamily: "'Arial', sans-serif", visibility: 'hidden', width: `${CONTENT_WIDTH_PX}px` }}></div>
          <div style={{ width: `${PAGE_WIDTH_PX}px`, display: 'flex', flexDirection: 'column', alignItems: 'center', boxShadow: '0 0 10px rgba(0,0,0,0.2)' }}>
            <div ref={appointmentLetterRef} style={{ width: `${PAGE_WIDTH_PX}px`, margin: 0, padding: 0, backgroundColor: '#fff', lineHeight: 0, fontSize: 0, display: 'block' }}>
              {isCalculatingPages ? (
                <div style={{ width: `${PAGE_WIDTH_PX}px`, height: `${PAGE_HEIGHT_PX}px`, display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#fff' }}> <Spinner animation="border" role="status"><span className="visually-hidden">Calculating Pages...</span></Spinner> </div>
              ) : renderedPagesData.length > 0 ? (
                renderedPagesData.map((pageContent, index) => (
                  <div key={index} className="appointment-letter-page" style={{ width: `${PAGE_WIDTH_PX}px`, height: `${PAGE_HEIGHT_PX}px`, backgroundColor: "#ffffff", position: "relative", overflow: "hidden", fontFamily: "'Arial', sans-serif", fontSize: "10px", color: "black", lineHeight: "1.3", boxSizing: "border-box", margin: 0, padding: 0, display: 'block' }}>
                    <img src={appointmentLetterBackgroundImage} alt={`Background Page ${index + 1}`} style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: 1 }} />
                    {index === 0 && renderHeader()}
                    {safeData.generationMethod === 'template' && index === 0 ? renderAppointmentTemplateContent() :
                      safeData.generationMethod === 'custom' ? renderCustomContent(pageContent, index) :
                        <p style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', zIndex: 2, color: 'red' }}>Invalid Method</p>
                    }
                    {index === renderedPagesData.length - 1 && renderFooter()}
                  </div>
                ))
              ) : (
                <div style={{ width: `${PAGE_WIDTH_PX}px`, height: `${PAGE_HEIGHT_PX}px`, backgroundColor: "#ffffff", position: "relative", overflow: "hidden" }}> <img src={appointmentLetterBackgroundImage} alt="Background Page 1" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: 1 }} /> <p style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 2, color: 'grey' }}>No content.</p> </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppointmentLetter;